/* Step 13 · P4 (lane S13A) — Founder → Maintenance: "Run on" starts empty (P4.1) and deleted firms (P4.5), EN + AR. */
const I18N_S13P4 = {
  en: {
    s13p4: {
      chooseWhere: "Choose where to run",
      deleted: "(deleted)",
      includeDeletedFirms: "Include deleted firms",
      includeDeletedFirmsHint: "Read-only checks only: also read the firms in the Recycle Bin. Fix and apply scripts never write to a deleted firm.",
    },
  },
  ar: {
    s13p4: {
      chooseWhere: "اختر مكان التشغيل",
      deleted: "(محذوفة)",
      includeDeletedFirms: "تضمين الشركات المحذوفة",
      includeDeletedFirmsHint: "لفحوص القراءة فقط: تُقرأ أيضاً الشركات الموجودة في سلة المحذوفات. لا تكتب برامج الإصلاح والتطبيق أبداً في شركة محذوفة.",
    },
  },
};

export default I18N_S13P4;
